package org.moxultimate.topwithmox.components.texts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.backgroundImage
import org.jetbrains.compose.web.css.px
import org.moxultimate.topwithmox.theme.FontFamily

@Composable
fun MoxGradientText (
    text: String,
    fontSize: Int = 16,
    fontWeight: FontWeight = FontWeight.SemiBold,
    modifier: Modifier = Modifier,
) {
    SpanText(
        text = text,
        modifier = modifier
            .moxTextGradient()
            .fontSize(fontSize.px)
            .fontFamily(FontFamily)
            .fontWeight(fontWeight)
    )
}


/**
 * Applies a text gradient matching the ic_mox2 color spectrum.
 * It clips the background gradient to the text bounds and makes the text fill transparent.
 */
fun Modifier.moxTextGradient(): Modifier = this.styleModifier {
    // 1. Define the exact linear gradient stops from the image (Left to Right)
    backgroundImage(
        "linear-gradient(to right, #f47b20 0%, #e61a26 30%, #8b3a8a 55%, #1d71b8 80%, #46b7e6 100%)"
    )

    // 2. Clip the background gradient strictly to the text shape
    property("-webkit-background-clip", "text")
    property("background-clip", "text")

    // 3. Make the internal font color transparent so the background gradient shines through
    property("-webkit-text-fill-color", "transparent")
    property("color", "transparent")
}